export const LOWERCASE_ALPHA = 'abcdefghijklmnopqrstuvwxyz';
export const UPPERCASE_ALPHA = LOWERCASE_ALPHA.toUpperCase();
export const NUMERIC = '0123456789';
export const ALPHANUMERIC = `${LOWERCASE_ALPHA}${UPPERCASE_ALPHA}${NUMERIC}`;

const randomString = (length, alphabet = ALPHANUMERIC) =>
  new Array(length).fill(1).map(() => alphabet[Math.floor(Math.random() * alphabet.length)]).join('');

export default randomString;